/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Alpha_Illustration_AltInputs */

const en_landing_capability_alpha_illustration_alt = /** @type {(inputs: Landing_Capability_Alpha_Illustration_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A research library where every archive is indexed and searchable`)
};

/**
* | output |
* | --- |
* | "A research library where every archive is indexed and searchable" |
*
* @param {Landing_Capability_Alpha_Illustration_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_alpha_illustration_alt = /** @type {((inputs?: Landing_Capability_Alpha_Illustration_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Alpha_Illustration_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_alpha_illustration_alt(inputs)
});